import {Local} from './Local';

export const en: Local = {
  translation: {
    language: {
      label: 'Language',
      en: 'English',
      ar: 'العربية',
    },
    theme: 'Theme',
    validation: {
      requiredField: 'Required field',
      mustBePositive: 'Must be Positive',
    },
    general: {
      enable: 'Enable',
      enableAll: 'Enable All',
      homePage: 'Set as Homepage',
      home: 'Home',
    },
    publish: 'Publish',
    notifications: 'Notifications',
    tags: 'Tags',
    clearFilters: 'Clear Filters',
    filter: 'Filter',
    sort: 'Sort',
    login: 'Login',
    logout: 'Logout',
    confirmDeletion: 'Confirm Deletion',
    generalErrorMsg: 'Sorry, something went wrong.',
    successDelMsg: 'Alternative logo deleted successfully',
    successMsg: 'Done, Successfully',
    warning: 'Warning',
    action: {
      new: 'New',
      edit: 'Edit',
      delete: 'Delete',
      add: 'Add',
      save: 'Save',
      undo: 'Undo',
      redo: 'Redo',
      apply: 'Publish',
      cancel: 'Cancel',
      preview: 'Preview',
      set: 'Set',
      open: 'Open',
      accept: 'Accept',
      close: 'Close',
      refresh: 'Refresh',
    },
    dashboard: 'Dashboard',
    dashboardHeader: 'Header',
    dashboardFooter: 'Footer',
    designer: 'Designer',
    'api-resource': 'Api Resource',
    'global-variables': 'Global Variables',
    configurations: 'Configurations',
    services: 'E-Services',
    configurationsOf: 'Configurations Of',
    properties: 'Properties',
    layers: 'Layers',
    deleteMsgConfirmation: 'Are you sure you want to delete this?',
    builder: {
      changeTheme: 'Change Theme',
      group: 'Group',
      createScope: 'Create Scope',
      createPageState: 'Create page state',
      stateCreated: 'State created successfully',
      noPageInEditMode: 'No page in edit mode',
      arrayPlaceholder: 'Enter array (e.g., [1, 2, 3])',
      jsonPlaceholder: 'Enter JSON object (e.g., {"key": "value"})',
      booleanPlaceholder: 'Enter Boolean (e.g., true or false )',
      when: 'When',
      do: 'Do',
      on: 'On',
      if: 'If',
      then: 'Then',
      else: 'Else',
      finally: 'Finally',
      event: 'Event',
      condition: 'Condition',
      success: 'Success',
      failed: 'Failed',
      finish: 'Finish',
      addEvent: 'Add Event',
      addActionGroup: 'Add Action Group',
      editActionGroup: 'Edit Action Group',
      editEvent: 'Edit Event',
      addCondition: 'Add Condition',
      action: {
        action: 'Action',
        actions: 'Actions',
        addAction: 'Add Action',
        editAction: 'Edit Action',
        addActionGroup: 'Add Action Group',
        actionGroupNameUnique: 'Action group name must be unique',
        deleteActionGroupMsg: 'Deleting this action group will remove it from all usages. Do you want to proceed?',
        deleteEventMsg: 'Deleting this event will remove it definitely. Do you want to proceed?',
        deleteConditionMsg: 'Deleting this condition will remove definitely. Do you want to proceed?',
        deleteActionMsg: 'Deleting this action will remove it definitely. Do you want to proceed?',
        actionConfig: 'Action Config',
        actionDefinition: 'Action Definition',
        actionDefinitionInfo: {
          title: 'Action Definition',
          label:
            'This section allows you to define the action that will be executed when the event is triggered. You can select an action from the list.',
        },
        actionsElement: {
          title: 'Configure Actions',
          label: 'Configure actions for the selected element. You can add, edit, or delete actions.',
        },
        actionConfigInfo: {
          title: 'Action Configuration',
          label:
            'Here you can configure the details of the selected action. Depending on the action type, you may need to provide additional parameters or settings.',
        },
      },
      state: {
        states: 'States',
        addState: 'Add State',
        editState: 'Edit State',
        createScope: 'Create Scope',
        editScope: 'Edit Scope',
        pageStateInfo: {
          title: 'Page State',
          label: `Page states allow you to define and manage dynamic data or conditions that control how a page behaves. 
They can also be used to define data and render it through Meta components.

For example, you can create states such as loading, error, or success. 
These states can then be managed by creating, editing, or deleting them as needed.`,
        },
        addStateInfo: {
          title: 'Create State',
          label:
            'Use this form to create a new state for the page. Each state must have a unique name, type, and value within the same scope.',
        },
        scopeInfo: {
          title: 'Scope',
          label:
            'Scopes are used to group states together. They help in organizing and managing states effectively. You can create, edit, or delete scopes as needed.',
        },
        createScopeInfo: {
          label:
            'Scopes allow you to group related states together for better organization. Each scope name must be unique, and it’s recommended to use a descriptive name to manage your data more effectively.',
        },
      },
      resource: {
        title: 'Resource',
        addRequest: 'Add Request',
        editRequest: 'Edit Request',
        addCollection: 'Add Collection',
        editCollection: 'Edit Collection',
        info: {
          label: `Page Resources are used to manage API requests and collections on the page level. 
  You can create, edit, or delete API requests and collections as needed.

  Please note: All API requests and collections must first be defined in the API Dashboard before they can be used on a page.`,
        },
        addCollectionInfo: {
          label: `This form allows you to select a collection that you have already created in the API dashboard.  
Once added, the collection will be linked to the current page, giving you direct access to its associated resources and making it easier to manage them within the page.`,
        },
        addRequestInfo: {
          label: `Use this form to select an API request that you have already created in the API Dashboard. 
Once added, the request will be linked to the current page, allowing you to easily access and use its response data within the page.`,
        },
      },
      deleteScopeMsg: 'Deleting this scope will remove it from all usages. Do you want to proceed?',
      deleteStateMsg: 'Deleting this state will remove it from all usages. Do you want to proceed?',
      deleteCollectionMsg: 'Deleting this collection will remove it from all usages. Do you want to proceed?',
      deleteApiRequestMsg: 'Deleting this request will remove it from all usages. Do you want to proceed?',
      noEvents: "This element doesn't provide any events",
      status: 'Status',
      selectCollection: 'Select Collection',
      selectRequest: 'Select Request',
      loadingThinking: 'Thinking...',
      loadingGeneratingResponse: 'Generating response...',
      loadingFetchingData: 'Fetching data...',
      loadingComposingAnswer: 'Composing the best answer...',
      loadingCheckingSources: 'Double-checking sources...',
      loadingFinalTouches: 'Adding final touches...',
      loadingAlmostDone: 'Almost done...',
      aiBuilder: 'AI Builder',
      viewPortInfo: {
        desktop: {
          label: 'Desktop',
          description: 'The default viewport. Styles set here apply to all devices unless overridden.',
        },
        tablet: {
          label: 'Tablet',
          description: 'Styles set here override Desktop and apply only to tablet-sized screens.',
        },
        mobile: {
          label: 'Mobile',
          description: 'The smallest viewport. Styles here override both Desktop and Tablet for mobile optimization.',
        },
      },
      addElement: {
        title: 'Add Element',
        label:
          'Select an element from the list to add it to your page. You can customize its properties and styles after adding it.',
      },
      designElement: {
        title: 'Design Element',
        label: 'This section allows you to customize the design of the selected element.',
      },
      actionsElement: {
        title: 'Configure Actions',
        label: 'Configure actions for the selected element. You can add, edit, or delete actions .',
      },
      AiElement: {
        label:
          'This section allows you to generate pages using AI. Enter your prompt and let the AI assist you in creating content.',
      },
      eventInfo: {
        title: 'Event',
        label:
          'Events define when actions should run. Choose an event (like a Press or Load) to configure the actions it triggers.',
      },
      actionGroupInfo: {
        title: 'Event Group',
        label:
          'Event groups let you organize multiple events together. You can add, edit, or delete groups, set conditions before an event is triggered, and even bind multiple groups for more complex flows.',
      },
    },
    settings: {
      settings: 'Settings',
      pageSettings: 'Page Settings',
      pageSettingsInfo: {
        label:
          'In Page Settings, you can manage all global configurations related to the page, such as the page name, icon, and other settings.',
      },
      pageTitle: 'Page title',
      pageIcon: 'Page icon',
      addWidget: 'Add Widget',
      clickToEdit: 'Click on a component to start editing.',
      insertRow: 'Insert new row',
      spacing: 'Spacing',
      measures: 'Measures',
      alignment: 'Alignment',
      noSectionsMsgTitle: 'Create a section first',
      noSectionsMsg:
        'To start editing you need first to create a section, Hover over the editor you well see a (+) button , hit the button and you are good to go or from the below button',
      layout: {
        label: 'Layout',
        width: 'Width',
        minWidth: 'Min Width',
        maxWidth: 'Max Width',
        height: 'Height',
        minHeight: 'Min Height',
        maxHeight: 'Max Height',
        margin: 'Margin',
        padding: 'Padding',
        resizeMode: 'Resize Mode',
        contain: 'Contain',
        cover: 'Cover',
        stretch: 'Stretch',
        repeat: 'Repeat',
        center: 'Center',
        left: 'Left',
        right: 'Right',
        top: 'Top',
        bottom: 'Bottom',
        gap: 'gap',
      },
      style: {
        label: 'Style',
        opacity: 'Opacity',
        color: 'Color',
        background: 'Background',
        backgroundColor: 'Background color',
      },
      typography: {
        label: 'Typography',
        initialText: 'Your content goes here. Edit styles and content or remove this text From the side bar',
        fontSize: 'Size',
        fontWeight: 'Weight',
        textAlign: 'Align',
        start: 'Start',
        left: 'Left',
        right: 'Right',
        center: 'Center',
        thin: 'Thin',
        normal: 'Normal',
        bold: 'Bold',
        lineHeight: 'line Height',
      },
      basic: {
        label: 'Basic',
        text: 'Text',
        url: 'URL',
      },
      button: {
        empty: 'empty',
        filled: 'filled',
        outlined: 'outlined',
        danger: 'danger',
        info: 'info',
        neutral: 'neutral',
        primary: 'primary',
        success: 'success',
        warning: 'warning',
        hierarchy: 'Hierarchy',
      },
      accordion: {
        newSection: 'New Section',
      },
      borders: {
        label: 'Borders',
        borderWidth: 'Border width',
        borderRadius: 'Border Radius',
        borderColor: 'Border Color',
        width: 'width',
        color: 'Color',
        radius: 'Radius',
      },
      flex: {
        label: 'Flex',
        direction: 'Direction',
        wrap: 'Wrap',
        align: 'Align',
        alignSelf: 'Align Self',
        justify: 'Justify',
        row: 'Row',
        column: 'Column',
        nowrap: 'No Wrap',
        wrapReverse: 'Wrap Reverse',
        flexStart: 'Start',
        flexEnd: 'End',
        center: 'Center',
        stretch: 'Stretch',
        spaceEvenly: 'Space Evenly',
        spaceBetween: 'Space Between',
        spaceAround: 'Space Around',
        grow: 'Grow',
      },
    },
    viewportSizes: {
      mobile: 'Mobile',
      tablet: 'Tablet',
      desktop: 'Desktop',
    },
    status: {
      SUCCEEDED: 'Succeeded',
      FAILED: 'Failed',
      RUNNING: 'Running',
      COMPLETED: 'Completed',
      SKIPPED: 'Skipped',
      NOT_STARTED: 'Not Started',
    },
    buildProfile: {
      PREVIEW: 'Preview',
      PRODUCTION: 'Production',
    },
    appConfig: {
      userInterface: 'User Interface',
      title: 'App',
      logo: 'Logo',
      alternativeLogo: 'Alternative Logo',
      miniLogo: 'Mini Logo',
      icon: 'Icon',
      icons: 'Icons',
      mobileIcons: 'Mobile Icons',
      appIcon: 'App Icon',
      splashScreen: 'Splash Screen',
      brandColors: 'Brand Color',
      generalSettings: 'General Settings',
      designSystem: {
        title: 'Design System',
        label:
          'The design system allows you to customize the visual aspects of your application. These settings help maintain a consistent brand identity across your app.',
      },
      brandColorInfo: {
        title: 'Brand Color',
        label: 'The main color that will be applied to the mobile and web application in both dark and light mode.',
      },
      appName: 'App Name',
      appNameInfo: {
        title: 'App Name',
        label: 'This is the name of your application that will be displayed in the web app.',
      },
      appIconInfo: {
        title: 'App Icon',
        label: 'This icon will appear in app stores and on the user’s device after installing the application.',
      },
      splashScreenInfo: {
        title: 'Splash Screen',
        label:
          'This image will be displayed while the app is loading. It provides a branded experience before the app is fully ready.',
      },
      appLogoInfo: {
        title: 'App Logo',
        label:
          'The main logo of the application. It will appear in the navigation bar and represent the app’s brand identity.',
      },
      alternativeLogoInfo: {
        title: 'Alternative Logo',
        label: 'This logo will be used in dark mode. If not provided, the main app logo will be displayed instead.',
      },
      miniLogoInfo: {
        title: 'Mini Logo',
        label:
          'This logo will be displayed when the sidebar is collapsed. It is typically a compact version of the main logo, and is also used as the favicon.',
      },
      settings: 'Settings',
      enableSettings: 'Display Settings',
      enableSettingsInfo: {
        title: 'Display Settings',
        label: 'Toggle this option to show or hide the Settings page in your application.',
      },
    },
    mobileReleaseHub: {
      title: 'Mobile Release Hub',
      mobileIcons: 'Mobile Icons',
      buildApp: 'Build App',
      updateApp: 'Update App',
      publish: 'Publish',
      publishApp: 'Publish App',
      publishAppInfo: 'Publish to stores',
      runHistory: 'Run History',
      downloadApp: 'Download App',
      android: 'Android',
      ios: 'IOS',
      all: 'All',
      none: 'None',
      buildError: 'Build Error',
      actions: 'Actions',
      deleteBuild: {
        title: 'Delete Build',
        message: 'Are you sure you want to delete this build? This action cannot be undone.',
        error: 'Error happened when deleting the build',
        success: 'Build successfully deleted',
      },
      failedToFetchConfig: 'Failed To Fetch Config',
      loadingConfig: 'Loading Config',
      configuration: 'Configuration',
      error: 'Error',
      appName: 'App Name',
      appVersion: 'App Version',
      easOwner: 'EAS Owner',
      easProjectId: 'EAS Project ID',
      steps: 'Steps',
      status: 'Status',
      buildStatus: 'Build Status',
      publishStatus: 'Publish Status',
      buildHistory: 'Build History',
      testConnection: 'Test Connection',
      easConfig: 'EAS Configuration',
      platform: 'Platform',
      selectPlatform: 'Select Platform',
      channel: 'Channel',
      newBuildsOccurMessage: 'The maximum number of builds depends on your EAS account plan.',
      somethingWentWrong: 'Something went wrong',
      easConnectedSuccessfully: 'EAS Connected successfully',
      doneSuccessfully: 'Done Successfully',
      usernameOrPasswordIncorrect: 'Username or password is incorrect',
      easToken: 'EAS Token',
      previewApp: 'Preview App',
      ascAppId: 'ASC App ID',
      androidTrack: 'Android Track',
      selectAndroidTrack: 'Select Android Track',
      profile: 'Profile',
      selectProfile: 'Select Profile',
      preview: 'Preview',
      production: 'Production',
      syncSourceCode: 'Sync Source Code',
      authPackageRegistry: 'Auth Package Registry',
      configureApplets: 'Configure Applets',
      configureApp: 'Configure App',
      installPackages: 'Install Packages',
      buildAndroid: 'Build Android',
      buildIos: 'Build iOS',
      publishToPlayStore: 'Publish to Play Store',
      publishToAppStore: 'Publish to App Store',
      repositoryUpdated: 'Repository Updated',
      registryLoggedIn: 'Registry LoggedIn',
      appletsUpdated: 'Applets Updated',
      appConfigMapped: 'Config Updated',
      packagesInstalled: 'Packages Installed',
      deployAndroidSent: 'Deploy Android Sent',
      deployIosSent: 'Deploy IOS Sent',
      updateCompleted: 'Update Completed',
      otaHistory: 'Direct Update History',
      otaUpdate: 'Live Updates',
      otaUpdateAction: 'Push Update',
      otaUpdateInfo: {
        title: 'Live Updates',
        label:
          'Over-The-Air (OTA) updates allow your app to receive new features or fixes without requiring users to download a new version from the store.',
      },
      buildDeploy: {
        title: 'App Releases',
        label: 'Create preview or production builds for Android and iOS, track build status, and publish releases to the app stores.',
      },
    },
    aiAssistant: {
      enable: 'Enabled',
      disable: 'Disabled',
      apiKeyLabel: 'API Key',
      apiKeyDescription: 'Enter your AI service API key to enable AI features in your application.',
      apiKeyDescriptionExist: 'An API key is already set. Enter a new one to replace it.',
      title: 'AI Assistant',
      promptTitle: 'Describe what you want to create',
      promptHint:
        'Tip: Write clear and specific instructions. Mention the layout, elements, or style you want. The more detail you give, the better the AI can match your vision.',
      placeholder: 'E.g. Create a login page with email, password, and a sign-in button',
      info: {
        title: 'AI Assistant',
        label:
          'The AI Assistant can help you generate pages. It uses advanced AI models to understand and respond to your queries.',
      },
      apiKeyInfo: {
        title: 'API Key',
        label:
          'The API key is required to authenticate your requests to the AI service. Currently we support OpenAI service.',
      },
    },
    homeConfig: {
      title: 'Components Customizations',
      enable: 'Enable/Disable',
    },
    appletConfig: {
      enable: 'Enable/Disable',
      componentsCustomizations: 'Components Customizations',
      pleaseEnableConnector: 'To view available services, please enable this connector',
      general: 'General',
    },
    servicesAuthorization: {
      title: 'Services Authorization',
    },
    generalConfig: {
      title: 'General',
    },
    apiSettings: {
      request: 'Request',
      noCollectionSelected: 'No API request has been selected yet for this collection',
      noCollectionSelectedDes: 'Please create an API request first',
      apiUrl: 'URL',
      method: 'Method',
      headers: 'Headers',
      queryParams: 'Query Params',
      addHeader: 'Add header',
      key: 'Key',
      value: 'Value',
      body: 'Body',
      preview: 'Preview',
      mapResponse: 'Map Response',
      testAndMapApi: 'Test and Map Response',
      sendApi: 'Send',
      apiResponse: 'Response',
      recommended: 'Recommended',
      addJsonPath: 'Add JSON Path',
      predefinedPath: 'Predefined Path',
      jsonPath: 'JSON Path',
      name: 'Name',
      type: 'Type',
      enterCollectionTitle: 'Type collection title...',
      apiDetails: 'Details',
      collection: 'Collection',
      addCollection: 'Add Collection',
      defaultValue: 'Default value',
      collections: 'Collections',
      setValue: 'Set value From API',
      editAPIName: 'Edit Collection',
      addQueryParam: 'Add Query param',
      apiUpdated: 'API request updated',
      apiDeleted: 'API request Deleted',
      deleteApiRequestMsg: 'Deleting this API request will remove it from all usages. Do you want to proceed?',
      deleteCollectionMsg: 'Deleting this collection will remove it from all usages. Do you want to proceed?',
      fetchCollectionMsgErr: 'Something went wrong while fetching Collection from API',
      collectionDeleted: 'Collection deleted successfully',
    },
    globalVariables: {
      name: 'Global Variables',
      scopes: 'Scopes',
      scope: 'Scope',
      createScope: 'Create Scope',
      createVariable: 'Create Variable',
      variable: 'Variable',
      editVariable: 'Edit Variable',
      secret: 'Secret',
      deleteVariableMsg: 'Deleting this variable will remove it from all usages. Do you want to proceed?',
      variableName: 'Name',
      variableValue: 'Value',
      variableType: 'Type',
      scopeName: 'Scope Name',
      editScope: 'Edit Scope',
      deleteScopeMsg: 'Deleting this scope will remove it from all usages. Do you want to proceed?',
      editVariableSuccess: 'Variable is updated successfully',
      createVariableSuccess: 'Variable is created successfully',
      deleteVariableSuccess: 'Variable is deleted successfully',
      editScopeSuccess: 'Scope is updated successfully',
      createScopeSuccess: 'Scope is created successfully',
      deleteScopeSuccess: 'Scope is deleted successfully',
      nameRequired: 'Name is required',
      valueRequired: 'Value is required',
    },
    name: 'Name',
    value: 'Value',
    public: 'Public',
    private: 'Private',
    elements: 'Elements',
    widgets: 'Widgets',
    content: 'Content',
    header: 'header',
    design: 'Design',
    variant: 'Variant',
    type: 'Type',
    pages: 'Pages',
    section: 'Section',
    container: 'Container',
    changeIcon: 'Change Icon',
    selectRequiredRoles: 'Select Required Roles',
    servicePage: 'Service Page',
    contentPage: 'Content Page',
    selectService: 'Select Service',
    auxiliaryPages: 'Auxiliary Pages',
    auxiliaryPage: 'Auxiliary Page',
    auxiliaryPagesInfo:
      'Auxiliary pages are additional pages that can be used to provide extra functionality or information within your application. They are added to the settings page.',
    pagesGroup: 'Pages Group',
    upload: 'Upload',
    others: 'Others',
    placeholder: 'Placeholder',
    sessions: {
      title: 'Sessions',
      enable: 'Enabled',
      disable: 'Disabled',
      sessionTimeout: 'Session Time Limit',
      info: {
        title: 'Session Management',
        label:
          'Session management allows you to control user sessions, including setting a time limit for inactivity. This helps enhance security by automatically logging out users after a specified period of inactivity.',
      },
    },
    customerSurvey: {
      title: 'Customer Survey',
      enable: 'Enabled',
      disable: 'Disabled',
      info: {
        title: 'Customer Survey',
        label:
          'Customer Survey lets you collect user feedback through Formbricks to improve the app and user experience.',
      },
      environmentId: 'Environment ID',
      appUrl: 'App URL',
      autoTriggerKey: 'Auto Trigger Key',
      autoTriggerKeyInfo: 'The auto trigger key is required to automatically trigger the customer survey.',
    },
    home: 'Home',
    highlighted: 'Highlighted',
    pushNotification: {
      title: 'Push Notification',
      hint: 'Upload the required Firebase configuration files (for Android and iOS) to enable push notifications in your app. If not added, the default configuration files will be used.',

      android: {
        title: 'Android Configuration',
        placeholder: 'Drop google-services.json file here or click to browse',
        hint: 'Upload the google-services.json file from your Firebase Console to enable push notifications for Android',
      },
      ios: {
        title: 'iOS Configuration',
        placeholder: 'Drop GoogleService-Info.plist file here or click to browse',
        hint: 'Upload the GoogleService-Info.plist file from your Firebase Console to enable push notifications for iOS',
      },
    },
  },
};
